import { makeStyles } from 'tss-react/mui'


export const useStyles = makeStyles()((theme) => {
    return {
        container: {
            position: 'relative',
            display: 'grid',
            height: 'max-content',
            minHeight: '100%',
            maxHeight: '100%',
            gridTemplateRows: 'auto minmax(0, 1fr)',
            gridTemplateColumns: 'minmax(0px, 1fr)',
            gridTemplateAreas: '"header" "graph" "target-controls"',
            rowGap: '1px',
            width: '100%',
            flex: 1,
            userSelect: 'none',
            flexDirection: 'column',
            borderRadius: 1
        },
        targetControls: {
            gridArea: "target-controls"
        },
        payoffGraph: {
            gridArea: "graph"
        }
    }
})